// Node Type
export const LEFT_NODE = 'nodeLeft';
export const RIGHT_NODE = 'nodeRight';
export const DROP_AREA = 'dropArea';

// DOM 操作相关
export const ROOT_PARENT = {id: '', children: []};
export const ROOT_NODE_ID = 'rmind_root_node';
export const MINDMAP_ID = 'rmind_mindmap_wrapper';
export const MINDMAP_MAIN = 'rmind_main'

// 缺省文本
export const NEW_NODE_TEXT = '新建节点';
export const DEFAULT_TITLE = '未命名导图';

// CSS 主题变量名
export const THEME_MAIN = '--theme-main';
export const THEME_LIGHT = '--theme-light';
export const THEME_DARK = '--theme-dark';
export const THEME_EX = '--theme-ex';
export const THEME_ASSIST = '--theme-assist';